var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
import { __decorate, __metadata } from "tslib";
import contService from "@/core/services/contService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Centro_CustoActions } from "@/store/enums/ContEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Centro_CustoModule = class Centro_CustoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Centro_CustoActions.POST_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.post("Centro_Custo/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Centro_CustoActions.PUT_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.put("Centro_Custo/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Centro_CustoActions.PUTRANGE_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.put("Centro_Custo/PutRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Centro_CustoActions.DELETE_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.delete("Centro_Custo/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Centro_CustoActions.DELETE_RANGE_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.post("Centro_Custo/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Centro_CustoActions.FILTER_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.post("Centro_Custo/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Centro_CustoActions.GET_CENTRO_CUSTO]() {
        return new Promise(resolve => {
            contService.get("Centro_Custo/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Centro_CustoActions.GETWITHDISABLED_CENTRO_CUSTO]() {
        return new Promise(resolve => {
            contService.get("Centro_Custo/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Centro_CustoActions.GETWITHDISABLEDWITHDESPESAS_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.get("Centro_Custo/GetWithDisabledWithDespesas", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Centro_CustoActions.GETCENTROCUSTOBYUSUARIO]() {
        return new Promise(resolve => {
            contService.get("Centro_Custo/GetCentroCustoByUsuario")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_l = Centro_CustoActions.GET_BY_ID_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.get("Centro_Custo/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_m = Centro_CustoActions.GETCENTROCUSTOBYIDCOLABORADOR_CENTRO_CUSTO](data) {
        return new Promise(resolve => {
            contService.get("Centro_Custo/GetCentroCustoByIdColaborador", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_o = Centro_CustoActions.GETBYCENTROCUSTOPROJETOECOLABORADORCENTRO_CUSTO](data) {
        return new Promise(resolve => {
            if (data.idColaborador) {
                contService.get(`Centro_Custo/GetbyCentroCustoProjetoEColaborador/${data.idProjeto}/${data.idColaborador}`)
                    .then(({ data }) => {
                    resolve(data);
                })
                    .catch(({ response }) => {
                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
                });
            }
            else {
                contService.get("Centro_Custo/GetbyCentroCustoProjeto", data.idProjeto)
                    .then(({ data }) => {
                    resolve(data);
                })
                    .catch(({ response }) => {
                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
                });
            }
        });
    }
    [_p = Centro_CustoActions.GETBYCENTROCUSTOPROJETO](data) {
        return new Promise(resolve => {
            contService.get("Centro_Custo/GetbyCentroCustoProjeto", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_q = Centro_CustoActions.GETMERGE_PROJETO_CENTRO](data) {
        return new Promise(resolve => {
            contService.post("Centro_Custo/GetMergeProjetoCentroCustoByUsuariosId", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_r = Centro_CustoActions.GETMERGE_PROJETO_CENTRO_BY_COLABORADORID](data) {
        return new Promise(resolve => {
            contService.get("Centro_Custo/GetMergeProjetoCentroCustoByColaboradorId", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _l, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _m, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _o, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _p, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _q, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Centro_CustoModule.prototype, _r, null);
Centro_CustoModule = __decorate([
    Module
], Centro_CustoModule);
export default Centro_CustoModule;
//# sourceMappingURL=Centro_CustoModule.js.map